import { Words } from '../types/lang'

export const getImaginativeItems = (words: Words) => {
  return [
    {
      name: words.classics,
      to: '/classic',
    },
    {
      name: words.poems,
      to: '/poem',
    },
    {
      name: words.history,
      to: '/history',
    },
    {
      name: words.detectives,
      to: '/detective',
    },

    {
      name: words.adventures,
      to: '/adventure',
    },
    {
      name: words.bestsellers,
      to: '/bestseller',
    },
    {
      name: words.novels,
      to: '/novel',
    },
    {
      name: words.folklore,
      to: '/folklore',
    },
    {
      name: words.dramaturgy,
      to: '/dramaturgy',
    },
    {
      name: words.fantasy,
      to: '/fantasy',
    },
  ]
}

export const getEducationalItems = (words: Words) => {
  return [
    {
      name: words.languages,
      to: '/language',
    },
    {
      name: words.scientific,
      to: '/scientific',
    },
    {
      name: words.manuals,
      to: '/manual',
    },
    {
      name: words.textbook,
      to: '/textbook',
    },

    {
      name: words.preschool,
      to: '/preschool',
    },
    {
      name: words.dictionaries,
      to: '/dictionarie',
    },
  ]
}

export const getChildrenItems = (words: Words) => {
  return [
    {
      name: words.upTo10Years,
      to: '/upTo10Year',
    },
    {
      name: words.tales,
      to: '/tale',
    },
    {
      name: words.gameBooks,
      to: '/gameBook',
    },
    {
      name: words.riddles,
      to: '/riddle',
    },

    {
      name: words.educationalCh,
      to: '/children_educational',
    },
    {
      name: words.fables,
      to: '/fable',
    },
    {
      name: words.forTeens,
      to: '/forTeen',
    },
  ]
}

export const getItAndProgrammingItems = () => {
  return [
    {
      name: 'HTML',
      to: '/html',
    },
    {
      name: 'CSS',
      to: '/css',
    },
    {
      name: 'JavaScript',
      to: '/javascript',
    },
    {
      name: 'C',
      to: '/c',
    },
    {
      name: 'C++',
      to: '/c_plus_plus',
    },

    {
      name: 'C#',
      to: '/c_sharp',
    },
    {
      name: 'Pyton',
      to: '/pyton',
    },
    {
      name: 'Java',
      to: '/java',
    },
    {
      name: 'Swift',
      to: '/swift',
    },
    {
      name: 'PHP',
      to: '/php',
    },
    {
      name: 'TypeScript',
      to: '/typescript',
    },
    {
      name: 'Kotlin',
      to: '/kotlin',
    },
  ]
}

export const getOthersItems = (words: Words) => {
  return [
    {
      name: words.musical,
      to: '/musical',
    },
    {
      name: words.politics,
      to: '/politic',
    },
    {
      name: words.economy,
      to: '/economy',
    },
    {
      name: words.encyclopedias,
      to: '/encyclopedia',
    },

    {
      name: words.militaryScience,
      to: '/militaryScience',
    },
    {
      name: words.jurisprudence,
      to: '/jurisprudence',
    },
    {
      name: words.art,
      to: '/art',
    },
    {
      name: words.architecture,
      to: '/architecture',
    },
    {
      name: words.philosophy,
      to: '/philosophy',
    },
    {
      name: words.psychology,
      to: '/psychology',
    },
    {
      name: words.biography,
      to: '/biography',
    },
    {
      name: words.medicine,
      to: '/medicine',
    },
    {
      name: words.religious,
      to: '/religious',
    },
    {
      name: words.publicism,
      to: '/publicism',
    },
    {
      name: words.tourism,
      to: '/tourism',
    },
    {
      name: words.othersOthers,
      to: '/other_other',
    },
  ]
}
